import React from "react";
import { Container } from "react-bootstrap";
import { Fade, Zoom } from "react-awesome-reveal";
const Privacy = () => {
  return (
    <div className="register">
      {" "}
      <Container>
        {/* <div id="bar-progress" className="mt-5 mt-lg-0">
          <div className="step step-active">
            <h5>تجربة مجانية</h5>
          </div>
          <div className="seperator"></div>
          <div className="step ">
            <h5>30 جنية شهرياً</h5>
          </div>
          <div className="seperator"></div>
          <div className="step">
            <h5>300 جنية سنوياً</h5>
          </div>
        </div> */}
        <div className="main-reg">
          <div className="content-main" style={{ width: "90%" }}>
            <Zoom>
              <h2>"سياسة الخصوصية "</h2>
              <h4 style={{ lineHeight: "1.5" }}>
                بموافقتك على هذه الاتفاقية يمنحك “موقع أعمال سوفت وير” رخصة
                شخصية لاستخدام تطبيقاته محدودة بتاريخ انتهاء،غير حصرية، وغير
                قابلة للنقل، قابلة للإلغاء في حالة الإخلال بقواعد الاتفاقية أو
                القوانين، وذلك لدخول الموقع والاستفادة من البرامج وهذه الرخصة
                تخضع للشروط والأحكام المنصوص عليها في هذه الاتفاقية. واذا كنت
                مشترك يتبع مؤسسة فان “موقع أعمال سوفت وير” سوف يسمح لعدد من
                المستخدمين المسموح لهم باستخدام التطبيقات حسب الاتفاق بينك وبين
                “موقع أعمال سوفت وير” باستخدام الموقع أو التطبيقات والاستفادة من
                خدماتهم<i className="fa-solid fa-check"></i>
              </h4>
              <h5 style={{ lineHeight: "1.5" }}>
                فأذا كنت من الأفراد التي تدفع الأشتراك ، او سجلت الدخول لاستخدام
                التطبيقات كفترة تجريبية ، أو أنك تتصفح الموقع، فإن هذه الاتفاقية
                المبرمة بينك كفرد وبين “موقع أعمال سوفت وير”. هذا اتفاق قانوني
                ملزم، فإذا لم تستطيع فهم هذه الاتفاقية، أو لا توافق عليها ولن
                تلتزم بشروط الاستخدام وسياسة الخصوصية، عليك عدم التسجيل
                بالتطبيقات وغير مسموح لك بالوصول أو استخدام أي من الخدمات
                المتاحة عبر هذا الموقع، بموافقتك على التسجيل والوصول إلى استخدام
                الموقع فإنك تؤكد بأن عمرك لا يقل عن 18 عام، وبهذا يكون مسموح لك
                قانونياً بتسجيل الدخول إلى هذا الموقع، وأنك قرأت وتفهم ما جاء
                بهذه الاتفاقية وسوف تلتزم بشروطها. يمكنك دخول الموقع والاستفادة
                من خدمات التطبيقات للأغراض الشخصية او التجارية، وذلك فقط وفقاً
                لشروط الاستخدام وسياسة الخصوصية
              </h5>
              <h5>غير مسموح لك بـ :</h5>
            </Zoom>
            {/* <Fade direction="up">
              {" "}
              <p>
                أفضل وأسهل تطبيق سحابي لمتابعة أموالك وحساباتك الشخصية. ولا
                يتطلب أية خبرة في مجال المحاسبة
              </p>
            </Fade> */}
            <Fade direction="up">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> نقل أي حق من
                  حقوقك في هذه الاتفاقية لطرف ثالث
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>· دخول او استخدام
                  هذا الطرف الثالث لخدمات وبرامج الموقع والاستفادة منها
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  ادخال بيانات او معلومات لا تخصك، الدخول إلى خدمات أو حساب غير
                  مسموح لك باستخدامه، أو أي محاولة لانتهاك أي من عناصر ومقاييس
                  الأمان الخاصة بالموقع
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>· محاولة الدخول أو
                  الوصول إلى المعلومات البرمجية الهندسية الخاصة بأي من السوفت
                  وير" البرمجيات" الخاصة بالموقع .
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> · محاولة التدقيق
                  وفحص أو إسقاط الموقع، وخدماته أو انتهاك عناصر الأمان والوثائق
                  الخاصة بالموقع او الخدمات او السوفت وير"البرمجيات"، واذا تم
                  تعطيل أو حظر حسابك من قِبل موقع أعمال بعدم الدخول إلى الموقع
                  أو السوفت وير "البرمجيات" والخدمات ( وهذا من خلال منع عنوان
                  بروتوكول الانترنت الخاص بك)،
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> لا يحق انتحال
                  شخصية أي شخص أو كيان ، أو تزوير للحالة وهذا يشمل وعلى سبيل
                  المثال وليس الحصر _ المشترك الذي يتبع مؤسسة. السماح لأي طرف
                  ثالث لأجراء أي مما سبق ذكره.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> تعنى (سياسة
                  الخصوصية) لدينا بطريقة جمعنا وحفظنا واستخدامنا وطريقة حماية
                  معلوماتك الشخصية ومن المهم أن تقوم بالإطلاع على سياسة الخصوصية
                  هذه. ونقصد بالمعلومات الشخصية هي المعلومات التي ترتبط بشخص
                  معين أو مؤسسة والتي تستخدم في التعريف عنهم. • الموقع لا يأخذ
                  بعين الاعتبار أي معلومات مجهولة المصدر وغير مسؤول عنها •
                  بادخالك لمعلوماتك الشخصية تكون قد فوضتنا لمعالجة هذه المعلومات
                  وفق بنود وشروط (سياسة الخصوصية) .
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> قد نقوم بتعديل
                  (سياسة الخصوصية) في أي وقت وذلك من خلال الإعلان عن هذا التعديل
                  بنشر النسخة المعدلة على الموقع. وتكون النسخة المعدلة من (سياسة
                  الخصوصية) سارية المفعول اعتبارا من تاريخ نشرها. في اعقاب النشر
                  يعتبر استمرارك في استخدام الموقع موافقة منك بالشروط والبنود
                  الواردة في النسخة المعدلة لطريقة معالجتنا وتعاملنا مع معلوماتك
                  الشخصية التي كنت قد زودتنا بها. •نأمل منكم الإطلاع على الموقع
                  من حين لأخر للإعلانات عن أية تعديلات على سياسة الخصوصية.
                </li>
              </ul>
            </Fade>
            <Fade direction="up">
              <h5>حماية معلوماتك الشخصية</h5>
            </Fade>
            <Fade direction="up">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> كافة المعلومات
                  الشخصية مشفرة
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>يجب ان يتم ادخال
                  رقم الهاتف وكلمة السر في كل مرة عند الدخول الى حسابك أو القيام
                  بأية معاملات في الموقع.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  يجب أن يتم اختيار كلمة السر بحذر باستخدام أرقام وحروف واشكال
                  مميزة.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>لا تشارك كلمة السر
                  مع اي احد.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>في حالة أي إخلال
                  بقواعد القانون أو الأخلاق العامة من حق الشركة او ادارة الموقع
                  ايقاف الحساب الخاص بك بشكل مؤقت او دائم بما فيها الحسابات
                  المدفوع مقابلها دون الرجوع لصاحب الحساب ودون رد الأموال
                  المدفوعة لحين تصحيح أخطاء الحساب التي أوقف بسببها الحساب
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> لا يتحمل "موقع
                  أعمال" أي مسؤولية ويتم إعفاؤه من جميع الالتزامات والمسؤوليات
                  التعاقدية (على سبيل المثال عن الأضرار) إذا تأثر أداءه لهذه
                  الشروط والأحكام بحدث قوة قاهرة. وأي حدث لم يكن تحت سيطرة "موقع
                  أعمال"، أو لم يكن متوقعًا بشكل معقول، بما في ذلك، على سبيل
                  المثال لا الحصر، أي كارثة طبيعية مثل العواصف الرعدية أو
                  الفيضانات أو العواصف أو الحريق أو الطوارئ الوطنية أو الإضراب
                  أو الإجراءات العمالية المماثلة أو عدم توفر الإنترنت لأسباب
                  خارجة عن سيطرة "موقع أعمال".
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> وجب على "موقع
                  أعمال" تحمل المسؤولية عن أي خسارة أو ضرر ينشأ عن أو يرتبط بأي
                  شكل من الأشكال بأي من الوظائف أو الأستخدامات الموضحة بالموقع
                  أو تطبيقاته ، إلى أقصى حد مسموح به بموجب القانون، يجب ألا
                  تتجاوز المسؤولية الإجمالية المجمعة لـ "موقع أعمال" بأي حال من
                  الأحوال قيمة الاشتراك الشهري او السنوي للخدمة التي يدفعها
                  المستخدم.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> اذا كان لديك
                  أسئلة أو اهتمامات حول جمعنا واستخدامنا لمعلوماتك الشخصية
                  ,الرجاء الاتصال بفريق خدمة العملاء على رابط "تواصل معنا" على
                  “موقع أعمال سوفت وير”.
                </li>
              </ul>
            </Fade>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default Privacy;
